module.exports = __webpack_public_path__ + "resources/logo-sfinance.png";